module.exports = __webpack_public_path__ + "img/hollysprings_banner.jpg";